import script from "./AddressFrom.vue?vue&type=script&setup=true&lang=js"
export * from "./AddressFrom.vue?vue&type=script&setup=true&lang=js"

import "./AddressFrom.vue?vue&type=style&index=0&id=15191421&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15191421"]])

export default __exports__